export const DEFAULT_TIME_ZONE = 'UTC';

// @NOTE fallback for browsers without Intl.supportedValuesOf (Chrome < 99, Safari < 15.4)
const FALLBACK_TIME_ZONES = [
    'America/Los_Angeles',
    'America/Chicago',
    'America/New_York',
    'America/Sao_Paulo',
    'Europe/London',
    'Europe/Berlin',
    'Europe/Kyiv',
    'Asia/Jerusalem',
    'Asia/Dubai',
    'Asia/Kolkata',
    'Asia/Shanghai',
    'Asia/Tokyo',
    'Australia/Sydney'
];

const getSupportedTimeZones = () => {
    try {
        return Intl.supportedValuesOf('timeZone');
    } catch (error) {
        return FALLBACK_TIME_ZONES;
    }
};

const getOffsetLabel = timeZone => {
    try {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone,
            timeZoneName: 'shortOffset'
        }).formatToParts(new Date());

        return parts.find(({ type }) => type === 'timeZoneName')?.value || '';
    } catch (error) {
        return '';
    }
};

let cachedOptions = null;

export default () => {
    if (cachedOptions) {
        return cachedOptions;
    }

    const timeZones = getSupportedTimeZones().filter(timeZone => timeZone !== DEFAULT_TIME_ZONE);

    cachedOptions = [DEFAULT_TIME_ZONE, ...timeZones].map(value => {
        const offset = getOffsetLabel(value);

        return {
            value,
            label: offset ? `${value} (${offset})` : value
        };
    });

    return cachedOptions;
};